import { graphql } from "gql.tada";

export {
  ANONYMOUS_QUERY_GROUP_ID,
  DEFAULT_QUERY_GROUP_ID,
  DEFAULT_URL_GROUP_ID,
} from "@/lib/analytics/group-ids";

export type LogicalOperator = ReturnType<
  typeof graphql.scalar<"LogicalOperator">
>;

// #region Query Group Pattern Type
export type QueryGroupPatternType = ReturnType<
  typeof graphql.scalar<"QueryGroupPatternType">
>;
export const QueryGroupPatternTypeLabels: Record<
  QueryGroupPatternType,
  ReturnType<typeof msg>
> = {
  CONTAINS: msg`Contains`,
  /**
   * @deprecated
   */
  INCLUDES: msg`Contains`,

  NOT_CONTAINS: msg`Does not contain`,
  /**
   * @deprecated
   */
  NOT_INCLUDES: msg`Does not contain`,

  STARTS_WITH: msg`Starts with`,
  ENDS_WITH: msg`Ends with`,
  EQUALS: msg`Equals`,
  REGEX: msg`Regex`,
  NOT_REGEX: msg`Does not match regex`,
};
export const QueryGroupPatternTypeOptions = Object.entries(
  QueryGroupPatternTypeLabels,
)
  .filter(([value]) => value !== "INCLUDES" && value !== "NOT_INCLUDES")
  .map(([value, label]) => ({ value, label }));
// #endregion

// #region URL Group Pattern Type
export type URLGroupPatternType = ReturnType<
  typeof graphql.scalar<"URLGroupPatternType">
>;

import { msg } from "@lingui/core/macro"; // Import msg macro
export const URLGroupPatternTypeLabels: Record<
  URLGroupPatternType,
  ReturnType<typeof msg>
> = {
  // Adjust type
  CONTAINS: msg`Contains`,
  INCLUDES: msg`Contains`, // Keep deprecated for compatibility if needed, or remove
  NOT_INCLUDES: msg`Does not contain`, // Keep deprecated for compatibility if needed, or remove
  NOT_CONTAINS: msg`Does not contain`,
  STARTS_WITH: msg`Starts with`,
  ENDS_WITH: msg`Ends with`,
  EQUALS: msg`Equals`,
  REGEX: msg`Regex`,
  NOT_REGEX: msg`Does not match regex`,
  SUB_DOMAIN: msg`Sub domain is`,
  DEPTH1: msg`First path is`,
  DEPTH2: msg`Second path is`,
  DEPTH3: msg`Third path is`,
};
export const URLGroupPatternTypeOptions = Object.entries(
  URLGroupPatternTypeLabels,
)
  .filter(([value]) => value !== "INCLUDES" && value !== "NOT_INCLUDES")
  .map(([value, label]) => ({ value, label }));
// #endregion
